import React from "react";
import { TableSection } from "../TableSection/TableSection";
import {RowOptions } from "../TableSection/TableSection";
import CodeAlongLogo from "../../Photos/codealongs-logo.svg"
import "./CodeAlong.scss"
import { SectionProps } from "../../App";

interface CodeAlongProps {}

/**
 * Returns whether or not <assignment> should appear as released yet
 * @param assignment the assignment that should or should not be released
 * @return true if "now" is after/on the release date, false otherwise
 */
function shouldRelease(assignment: RowOptions): boolean {
    if (assignment.autoReleaseDate === undefined) {
      return true; // If no defined release date, treat it as released if it has an href
    }
    const now = new Date();
    // Convert now into EST, if it isn't already
    const nowEST = new Date(
            now.toLocaleString("en-US", {
            timeZone: "America/New_York",
        })
    );
    return nowEST > new Date(assignment.autoReleaseDate);
}

export class CodeAlong extends React.Component<SectionProps> {
  myHeader: string[] = [
    "Code-Along",
    "Related To",
    "Date",
    "Location",
    "Video",
    "Stencil",
  ];

  myRows: RowOptions[] = [
    {
      cellNames: [
        "Java Syntax",
        "Rattytouille, Andybot",
        "Sept 13,  4 - 5:30 PM",
        "MacMillan 117",
        "Video",
        "Stencil",
      ],
      cellNametoLinks: new Map<string, string>([
        ["Stencil", "https://github.com/brown-cs15-2025/codeAlong1"],
        ["Video", "https://www.youtube.com/watch?v=J6yTzBLuECM"],
      ]),
      autoReleaseDate: "Sep 13, 2025 14:00:00 EDT",
    },
    {
      cellNames: [
        "Writing Classes",
        "Pong, TicTacToe",
        "Sept 18,  7 - 8:30 PM",
        "MacMillan 117",
        "Video",
        "Stencil",
      ],
      cellNametoLinks: new Map<string, string>([
        ["Stencil", "https://github.com/brown-cs15-2025/codeAlong2"],
        ["Video", "https://www.youtube.com/watch?v=4E--9ET4GWk"],
      ]),
      autoReleaseDate: "Sep 18, 2025 15:00:00 EDT",
    },
    {
      cellNames: [
        "Polymorphism",
        "Fruit Ninja",
        "Oct 2,  5:30 - 7 PM",
        "Friedman 108",
        "Video",
        "Stencil",
      ],
      cellNametoLinks: new Map<string, string>([
        ["Stencil", "https://github.com/brown-cs15-2025/codeAlong3"],
        ["Video", "https://www.youtube.com/watch?v=R_Xz2vQkR60&t=2s"],
      ]),
      autoReleaseDate: "Oct 2, 2025 16:00:00 EDT",
    },
    {
      cellNames: [
        "JavaFX & Design",
        "Cartoon",
        "Oct 9,  8 - 9:30 PM",
        "Friedman 208",
        "Video",
        "Stencil",
      ],
      cellNametoLinks: new Map<string, string>([
        ["Stencil", "https://github.com/brown-cs15-2025/codeAlong4"],
        ["Video", "https://www.youtube.com/watch?v=421kJZUnx8s"],
      ]),
      autoReleaseDate: "Oct 9, 2025 18:30:00 EDT",
    },
    {
      cellNames: [
        "Github & Debugging",
        "Doodle Jump",
        "Oct 21,  5:30 - 7 PM",
        "MacMillan 117 ",
        "Video",
        "Stencil",
      ],
      cellNametoLinks: new Map<string, string>([
        ["Stencil", "https://github.com/brown-cs15-2025/codeAlong5"],
        ["Video", "https://www.youtube.com/watch?v=85f3dot1mEQ"],
      ]),
      autoReleaseDate: "Oct 21, 2025 15:30:00 EDT",
    },
    {
      cellNames: [
        "Tetris Pieces",
        "Tetris",
        "Nov 2 from 3 - 4:30 PM",
        "MacMillan 117",
        "Video",
        "Stencil",
      ],
      cellNametoLinks: new Map<string, string>([
        ["Stencil", "https://github.com/brown-cs15-2025/codeAlong6"],
        ["Video", "https://youtu.be/ycvdTQL9m1M?si=fVDcftjH3NzAgVDd"],
      ]),
      autoReleaseDate: "Nov 2, 2025 14:30:00 EDT",
    },
  ];

  render() {
    const modifiedRows: RowOptions[] = this.myRows.map((row) => {
      if (!shouldRelease(row)) {
        const updatedLinks = new Map<string, string>();

        // Iterate over the original links and replace or remove them if necessary
        row.cellNametoLinks.forEach((value, key) => {
          updatedLinks.set(key, "");
        });

        return {
          ...row,
          cellNametoLinks: updatedLinks,
          backgroundColor: "#FCD002aF",
        };
      }
      return row;
    });

    return (
      <section
        id="codealong"
        className={`anchor codealong ${this.props.static ? "static" : ""}`}
      >
        <center>
          <img
            className="codealong-logo logo"
            src={CodeAlongLogo}
            alt="codealong text"
          />
        </center>
        <TableSection
          header={this.myHeader}
          rows={modifiedRows}
          blurb={`CS15 Code-Alongs are your one stop shop for getting hands-on experience with guided coding exercises in order to better understand the concepts of OOP! We know that lectures can at times feel very abstract, and that we sometimes need examples in code in order to fully understand how these concepts work.
                Throughout the semester, we will host various code-alongs in order to assist you all with the skills necessary for succeeding in the course!`}
        />
      </section>
    );
  }
}
